import { getField, updateField } from "vuex-map-fields"
import {Api} from "@/plugins/axios"

export const state = () => ({
    loading: false,
    loadingTeams: false,
    activeTeam: null,
    teamMembers : [],
    teamError : null,
    teams : [],
    invites: [],
    loggedInUserMember : {}
})

export const actions = {
    async loadTeams({commit, dispatch, state}, options = null){
        // options is either a role string (existing callers) or { role, teamId }
        let role = options
        let teamId = null
        if ( options !== null && typeof options === 'object' ){
            role = options.role || null
            teamId = options.teamId || null
        }
        commit('loadingTeams', true)
        let { data : { teams } } = await Api.get('/api/v1/teams', { params : { role : role }})
        commit('setTeams', teams)
        commit('loadingTeams', false)
        if ( teams.length > 0 && !state.activeTeam ){
            let preferred = teamId ? teams.find(t => String(t.id) === String(teamId)) : null
            dispatch('loadActiveTeam', preferred || teams[0])
        }

    },
    async createTeam({commit, dispatch}, team){
        commit('loading', true)
        let { data } = await Api.post('/api/v1/teams', team)
        dispatch('loadTeams')
        commit('loading', false)
        return data
    },
    async editTeam({commit, dispatch}, team){
        commit('loading', true)
        let { data } = await Api.patch(`/api/v1/teams/${team.id}`, team)
        dispatch('loadTeams')
        commit('loading', false)
        return data
    },
    async loadActiveTeam({commit, dispatch}, team){
        commit('setActiveTeam', team)
        commit('loading', true)
        let { data : { teamMembers } } = await Api.get('/api/v1/teams/' + team.id + '/members')
        commit('setTeamMembers', teamMembers)
        let { data : { teamMember } } = await Api.get('/api/v1/teams/' + team.id + '/members/me')
        commit('setLoggedInUserTeamMember', teamMember)
        commit('loading', false)
        dispatch('getInvites')
    },
    async getInvites({commit, state}){
        commit('loading', true)
        commit('setInvites', [])
        try {
            let { data : { invites } } = await Api.get('/api/v1/teams/' + state.activeTeam.id + '/invites')
            commit('setInvites', invites)
        } catch (e){}
        commit('loading', false)
    }
}

export const getters = {
    getField
}

export const mutations = {
    updateField,
    loading(state, v){
        state.loading = v
    },
    loadingTeams(state, v){
        state.loadingTeams = v
    },
    setTeams(state, teams){
        state.teams = teams
    },
    setActiveTeam(state, team){
        state.activeTeam = team
    },
    setTeamMembers(state, members){
        state.teamMembers = members
    },
    setInvites(state, invites){
        state.invites = invites
    },
    setLoggedInUserTeamMember(state, teamMember){
        state.loggedInUserMember = teamMember
    }
}
